import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const useSupportPlanCriteriaStore = defineStore('supportPlanCriteria', () => {
    const all = ref({ data: [] });
    const active = ref({});
    const supportPlanCriteria = ref({});

    const reset = () => {
        all.value = { data: [] };
    };

    const searchSupportPlanCriteria = async (params) => {
        return axios.get(`/api/v1/support-plan/${params.hash}/criteria`, { params });
    };

    const storeSupportPlanCriteria = (params) => {
        return axios.post('/api/v1/support-plan/criteria/', params);
    };

    const updateSupportPlanCriteria = (params) => {
        return axios.patch(`/api/v1/support-plan/criteria/${params.hash}`, params);
    };

    const destroy = (params) => {
        return axios.delete('/api/v1/criteria/' + params.hash);
    };

    return {
        active,
        all,
        reset,
        storeSupportPlanCriteria,
        updateSupportPlanCriteria,
        destroy,
        searchSupportPlanCriteria,
        supportPlanCriteria,
    };
});
